import { Button, Card, CardContent, Grid, InputAdornment, MenuItem, TextField, Typography } from '@mui/material'
import { GreenText } from 'components'
import { useLayout } from 'context'
import { saveOhioTitleApplicationPacket } from 'controllers/ohioTitles/index'
import { BasicCompanyDto, BasicCompanyWithAddressesDto } from 'dtos/companies'
import { OhioTitleVehicleDto, OhioTitleVehicleDetailDto, OhioTitleDto } from 'dtos/ohioTitles'
import { BasicPersonDto } from 'dtos/people'
import { useFormikContext } from 'formik'
import { enqueueSnackbar } from 'notistack'
import { formatBasicAddress } from './SelectedVehicleCard'
import { ohioTitlesCompactButtonSx } from './ohioTitlesTableStyles'

interface Props {
  inspectionCompanies: BasicCompanyWithAddressesDto[]
  lienHolderCompanies: BasicCompanyWithAddressesDto[]
  documentSignerPeople: BasicPersonDto[]
  titleClerkPeople: BasicPersonDto[]
  vehicleGuid: string
  setSelected: React.Dispatch<React.SetStateAction<OhioTitleVehicleDto | undefined>>
  setState: React.Dispatch<React.SetStateAction<OhioTitleDto | undefined>>
}

export default function SelectedVehicleOhioTitleApplicationPacket({
  inspectionCompanies,
  lienHolderCompanies,
  documentSignerPeople,
  titleClerkPeople,
  vehicleGuid,
  setSelected,
  setState
}: Props) {
  const successMessage = 'Ohio Title Application Packet Saved Successfully!'
  const { setIsLayoutLoading } = useLayout()
  const { errors, handleBlur, handleChange, setFieldValue, validateForm, values } = useFormikContext<OhioTitleVehicleDetailDto>()

  return (
    <Card>
      <CardContent>
        <Grid container spacing={1} alignItems='center'>
          <Grid item xs={12}>
            <Typography fontWeight='bold' variant='h6'>
              Selected Vehicle - Ohio Title Application Packet
            </Typography>
          </Grid>

          <Grid item xs={12} container spacing={2} alignItems='flex-start' justifyContent='flex-start'>
            <Grid item xs={12} sm={4} container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleSellerName)}
                  fullWidth
                  helperText={errors.ohioTitleSellerName}
                  label='Seller Name'
                  name='ohioTitleSellerName'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleSellerName ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleSellerAddress1)}
                  fullWidth
                  helperText={errors.ohioTitleSellerAddress1}
                  label='Seller Address'
                  name='ohioTitleSellerAddress1'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleSellerAddress1 ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleSellerCity)}
                  fullWidth
                  helperText={errors.ohioTitleSellerCity}
                  label='Seller City'
                  name='ohioTitleSellerCity'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleSellerCity ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleSellerCounty)}
                  fullWidth
                  helperText={errors.ohioTitleSellerCounty}
                  label='Seller County'
                  name='ohioTitleSellerCounty'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleSellerCounty ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleSellerStateProvince)}
                  fullWidth
                  helperText={errors.ohioTitleSellerStateProvince}
                  label='Seller State/Province'
                  name='ohioTitleSellerStateProvince'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleSellerStateProvince ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleSellerPostalCode)}
                  fullWidth
                  helperText={errors.ohioTitleSellerPostalCode}
                  label='Seller Postal Code'
                  name='ohioTitleSellerPostalCode'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleSellerPostalCode ?? ''}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={4} container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOwnerName)}
                  fullWidth
                  helperText={errors.ohioTitleOwnerName}
                  label='Owner Name'
                  name='ohioTitleOwnerName'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleOwnerName ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOwnerAddress1)}
                  fullWidth
                  helperText={errors.ohioTitleOwnerAddress1}
                  label='Owner Address'
                  name='ohioTitleOwnerAddress1'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleOwnerAddress1 ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOwnerCity)}
                  fullWidth
                  helperText={errors.ohioTitleOwnerCity}
                  label='Owner City'
                  name='ohioTitleOwnerCity'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleOwnerCity ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOwnerCounty)}
                  fullWidth
                  helperText={errors.ohioTitleOwnerCounty}
                  label='Owner County'
                  name='ohioTitleOwnerCounty'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleOwnerCounty ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOwnerStateProvince)}
                  fullWidth
                  helperText={errors.ohioTitleOwnerStateProvince}
                  label='Owner State/Province'
                  name='ohioTitleOwnerStateProvince'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleOwnerStateProvince ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOwnerPostalCode)}
                  fullWidth
                  helperText={errors.ohioTitleOwnerPostalCode}
                  label='Owner Postal Code'
                  name='ohioTitleOwnerPostalCode'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleOwnerPostalCode ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOwnerIrsNumber)}
                  fullWidth
                  helperText={errors.ohioTitleOwnerIrsNumber}
                  label='Owner IRS #'
                  name='ohioTitleOwnerIrsNumber'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleOwnerIrsNumber ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOwnerDealerNumber)}
                  fullWidth
                  helperText={errors.ohioTitleOwnerDealerNumber}
                  label='Owner Dealer #'
                  name='ohioTitleOwnerDealerNumber'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.ohioTitleOwnerDealerNumber ?? ''}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={4} container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleInspectionCompanyGuid)}
                  fullWidth
                  helperText={errors.ohioTitleInspectionCompanyGuid}
                  label='Inspection Company'
                  name='ohioTitleInspectionCompanyGuid'
                  onBlur={handleBlur}
                  onChange={e => {
                    setFieldValue('ohioTitleInspectionCompanyGuid', e.target.value)
                    setFieldValue('ohioTitleInspectionCompanyAddressGuid', undefined)
                  }}
                  select
                  value={values.ohioTitleInspectionCompanyGuid ?? ''}
                >
                  {inspectionCompanies.map(company => (
                    <MenuItem key={company.companyGuid} value={company.companyGuid}>
                      {company.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleInspectionCompanyAddressGuid)}
                  fullWidth
                  helperText={errors.ohioTitleInspectionCompanyAddressGuid}
                  label='Inspection Company Address'
                  name='ohioTitleInspectionCompanyAddressGuid'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  select
                  value={values.ohioTitleInspectionCompanyAddressGuid ?? ''}
                >
                  {values.ohioTitleInspectionCompanyGuid &&
                    inspectionCompanies
                      .find(c => c.companyGuid === values.ohioTitleInspectionCompanyGuid)
                      ?.addresses.map(address => (
                        <MenuItem key={address.addressGuid} value={address.addressGuid}>
                          {formatBasicAddress(address)}
                        </MenuItem>
                      ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleLienHolderCompanyGuid)}
                  fullWidth
                  helperText={errors.ohioTitleLienHolderCompanyGuid}
                  label='Lien Holder Company'
                  name='ohioTitleLienHolderCompanyGuid'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  select
                  value={values.ohioTitleLienHolderCompanyGuid ?? ''}
                >
                  {lienHolderCompanies.map(company => (
                    <MenuItem key={company.companyGuid} value={company.companyGuid}>
                      {company.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleLienHolderCompanyAddressGuid)}
                  fullWidth
                  helperText={errors.ohioTitleLienHolderCompanyAddressGuid}
                  label='Lien Holder Company Address'
                  name='ohioTitleLienHolderCompanyAddressGuid'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  select
                  value={values.ohioTitleLienHolderCompanyAddressGuid ?? ''}
                >
                  {values.ohioTitleLienHolderCompanyGuid &&
                    lienHolderCompanies
                      .find(c => c.companyGuid === values.ohioTitleLienHolderCompanyGuid)
                      ?.addresses.map(address => (
                        <MenuItem key={address.addressGuid} value={address.addressGuid}>
                          {formatBasicAddress(address)}
                        </MenuItem>
                      ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleDocumentSignerPersonGuid)}
                  fullWidth
                  helperText={errors.ohioTitleDocumentSignerPersonGuid}
                  label='Document Signer'
                  name='ohioTitleDocumentSignerPersonGuid'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  select
                  value={values.ohioTitleDocumentSignerPersonGuid ?? ''}
                >
                  {documentSignerPeople.map(person => (
                    <MenuItem key={person.personGuid} value={person.personGuid}>
                      {person.firstName} {person.lastName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleTitleClerkPersonGuid)}
                  fullWidth
                  helperText={errors.ohioTitleTitleClerkPersonGuid}
                  label='Title Clerk'
                  name='ohioTitleTitleClerkPersonGuid'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  select
                  value={values.ohioTitleTitleClerkPersonGuid ?? ''}
                >
                  {titleClerkPeople.map(person => (
                    <MenuItem key={person.personGuid} value={person.personGuid}>
                      {person.firstName} {person.lastName}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleOdometerDisclosureStatementMileage)}
                  fullWidth
                  helperText={errors.ohioTitleOdometerDisclosureStatementMileage}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ endAdornment: <InputAdornment position='end'>MI</InputAdornment> }}
                  label='Odometer Disclosure Statement Mileage'
                  name='ohioTitleOdometerDisclosureStatementMileage'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type='number'
                  value={values.ohioTitleOdometerDisclosureStatementMileage ?? ''}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  error={Boolean(errors.ohioTitleVehiclePurchaseAgreementEffectiveDate)}
                  fullWidth
                  helperText={errors.ohioTitleVehiclePurchaseAgreementEffectiveDate}
                  InputLabelProps={{ shrink: true }}
                  label='Vehicle Purchase Agreement Effective Date'
                  name='ohioTitleVehiclePurchaseAgreementEffectiveDate'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  type='date'
                  value={values.ohioTitleVehiclePurchaseAgreementEffectiveDate ?? ''}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} container spacing={1} alignItems='center' justifyContent='flex-end' sx={{ mt: 4 }}>
            <Grid item>
              <Button
                color='primary'
                onClick={() => {
                  validateForm(values).then(errors => {
                    if (Object.keys(errors).length === 0) {
                      setIsLayoutLoading(true)
                      saveOhioTitleApplicationPacket(vehicleGuid, values, false)
                        .then(() => {
                          enqueueSnackbar(successMessage, { variant: 'success' })
                          setSelected(undefined)
                        })
                        .finally(() => setIsLayoutLoading(false))
                    }
                  })
                }}
                size='small'
                sx={ohioTitlesCompactButtonSx}
                variant='contained'
              >
                SAVE AND CLOSE
              </Button>
            </Grid>

            <Grid item>
              <Button
                color='primary'
                onClick={() => {
                  validateForm(values).then(errors => {
                    if (Object.keys(errors).length === 0) {
                      setIsLayoutLoading(true)
                      saveOhioTitleApplicationPacket(vehicleGuid, values, false)
                        .then(() => enqueueSnackbar(successMessage, { variant: 'success' }))
                        .finally(() => setIsLayoutLoading(false))
                    }
                  })
                }}
                size='small'
                sx={ohioTitlesCompactButtonSx}
                variant='contained'
              >
                SAVE
              </Button>
            </Grid>

            <Grid item>
              <Button
                color='primary'
                disabled={
                  !values.ohioTitleSellerName ||
                  !values.ohioTitleSellerAddress1 ||
                  !values.ohioTitleSellerCity ||
                  !values.ohioTitleSellerStateProvince ||
                  !values.ohioTitleSellerPostalCode ||
                  !values.ohioTitleOwnerName ||
                  !values.ohioTitleOwnerAddress1 ||
                  !values.ohioTitleOwnerCity ||
                  !values.ohioTitleOwnerCounty ||
                  !values.ohioTitleOwnerStateProvince ||
                  !values.ohioTitleOwnerPostalCode ||
                  // !values.ohioTitleOwnerIrsNumber ||
                  // !values.ohioTitleOwnerDealerNumber ||
                  !values.ohioTitleInspectionCompanyGuid ||
                  !values.ohioTitleInspectionCompanyAddressGuid ||
                  // !values.ohioTitleLienHolderCompanyGuid ||
                  !values.ohioTitleDocumentSignerPersonGuid ||
                  !values.ohioTitleTitleClerkPersonGuid ||
                  !values.ohioTitleOdometerDisclosureStatementMileage ||
                  !values.ohioTitleVehiclePurchaseAgreementEffectiveDate
                }
                onClick={() => {
                  validateForm(values).then(errors => {
                    if (
                      Object.keys(errors).length === 0 &&
                      window.confirm('Are you sure you wish to mark this application packet as Ready to Print? This cannot be undone.')
                    ) {
                      setIsLayoutLoading(true)
                      saveOhioTitleApplicationPacket(vehicleGuid, values, true)
                        .then(res => {
                          enqueueSnackbar(successMessage, { variant: 'success' })
                          setSelected(undefined)
                          setState(res.value)
                        })
                        .finally(() => setIsLayoutLoading(false))
                    }
                  })
                }}
                size='small'
                sx={ohioTitlesCompactButtonSx}
                variant='contained'
              >
                SAVE AND MARK APPLICATION PACKET READY TO PRINT
              </Button>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <GreenText variant='outlined'>
              {`**Seller Name Field:**

Displays the name of the Seller, which is sourced from the CAN Ownership documents.

The Seller is also referred to as:

   - “Previous Owner” on the Application for Certificate of Title (BMV 3774).
   - “Transferor” on the Odometer Disclosure Statement (BMV 3724).
   - “Seller” on the Vehicle Purchase Agreement.

**Seller Address Field:**

Displays the Address 1 and Address 2 values of the selected Seller merged into a single field (e.g., “123 Main St Suite A”).

**Seller City Field:**

Displays the city associated with the Seller's address.

**Seller County Field:**

Displays the county associated with the Seller's address.

**Seller State/Province Field:**

Displays the state or province associated with the Seller's address.

**Seller Postal Code Field:**

Displays the postal code associated with the Seller's address.

**Owner Name Field:**

Displays the name of the Owner, which will appear on the new vehicle title after the Title Application Packet is sent to the Ohio BMV.

The Owner is also referred to as:

   - “Primary Applicant” on the Application for Certificate of Title (BMV 3774).
   - “Transferee” on the Odometer Disclosure Statement (BMV 3724).
   - “Buyer” on the Vehicle Purchase Agreement.

**Owner Address Field:**

Displays the Address 1 and Address 2 values of the selected Owner merged into a single field (e.g., “123 Main St Suite A”).

**Owner City Field:**

Displays the city associated with the Owner's address.

**Owner County Field:**

Displays the county associated with the Owner's address.

**Owner State/Province Field:**

Displays the state or province associated with the Owner's address.

**Owner Postal Code Field:**

Displays the postal code associated with the Owner's address.

**Owner IRS# Field:**

Displays the IRS # of the selected Owner.

If the Exporter Company is selected as the Owner, the Exporter’s IRS # (from the Exporter Information card in Company Details) is displayed.

If the Registered Importer is selected as the Owner, the Registered Importer’s IRS # is displayed.

**Owner Dealer Number Field:**

Displays the Dealer Number of the selected Owner.

If the Exporter Company is selected as the Owner, the Exporter’s Dealer # (from the Exporter Information card in Company Details) is displayed.

If the Registered Importer is selected as the Owner, the Registered Importer’s Importer # is displayed.

**Inspection Company Name Field:**

Displays the name of the selected Inspection Company.

The Inspection Company dropdown lists all companies marked as “Inspection Company” in Company Details.

**Inspection Company Address Dropdown:**

Displays the address associated with the selected Inspection Company.

Populated with all addresses marked as “Inspection Company Address” in Company Details.

**Lien Holder Company Dropdown:**

Lists all companies marked as “Lien Holder Company” in Company Details.

**Document Signer Dropdown:**

Lists all authorized signers associated with the selected company or organization.

**Title Clerk Dropdown:**

Lists all People marked as “Title Clerk” under in the “Edit Person” dialog. Used to populate the “Name of Person Performing Inspection” on the “BMV 4334 – Out of State Motor Vehicle Physical Inspection” form.

**Odometer Disclosure Statement Mileage Field:**

Displays the vehicle’s odometer reading in miles, calculated based on the following:

   - If Convert Cluster = No: Displays “Vehicle Check-In Odometer in Miles”.
   - If Convert Cluster = Yes and Cluster Reinstall Complete = Not Populated: Displays “Vehicle Check-In Odometer in Miles”.
   - If Convert Cluster = Yes and Cluster Reinstall Complete = Populated: Displays the “Current Odometer Reading” as entered during the cluster reinstallation process.

Note: This value must always be in miles, not kilometers, and must be a whole number (no decimals).

**Vehicle Purchase Agreement Effective Date Picker:**

Allows users to select the effective date of the Vehicle Purchase Agreement.

The effective date is used to confirm the validity period of the agreement.

**SAVE AND CLOSE Button:**

Saves all entered information from the “Selected Vehicle – Ohio Title Application Packet” section into their respective fields on the Vehicle Details – Titles (tab) of the Ohio Title Application Packet card.

After saving, the vehicle is deselected and returned to the list of vehicles at the top of the Ohio Titles screen.

If a user later selects a vehicle from this list that already has saved Ohio Title Application Packet information, the information will be pre-populated into the input fields of the “Selected Vehicle – Ohio Title Application Packet” section.

**SAVE Button:**

Saves all entered information from the “Selected Vehicle – Ohio Title Application Packet” section into their respective fields on the Vehicle Details – Titles (tab) of the Ohio Title Application Packet card.

Does not deselect the vehicle or return it to the list of vehicles, allowing the user to continue editing the selected vehicle's information.

**SAVE AND MARK APPLICATION PACK READY TO PRINT Button:**

Becomes enabled only when all fields in the “Selected Vehicle – Ohio Title Application Packet” section are populated, except for:

   - Owner IRS#
   - Owner Dealer #
   - Seller County
   - Lien Holder Company
   - Lien Holder Company Address

When pressed, a confirmation pop-up appears with the message:

“Are you sure you wish to mark this application packet as Ready to Print? This cannot be undone.”

If the user confirms by pressing Yes, the selected vehicle is moved into the “Application Ready to Print” table.

The “Application Packet Ready to Print” column for that vehicle will also be updated.`}
            </GreenText>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}
